export function Enum() {
    return (target: any, key: string) => {
        target[key].setName(key);
    }
}
